import React from 'react';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section className="relative mb-16 md:mb-32 overflow-hidden min-h-[80vh] md:min-h-0">
      <img 
        src="https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/a235507e03397cd46f477e45632abe37.png"
        alt="ナインバレー株式会社 ヒーローイメージ"
        className="w-full h-[80vh] md:h-[80vh] object-cover object-top md:[object-position:center_40%]"
      />
      <div className="absolute inset-0">
        <div className="container mx-auto px-4 py-8 md:py-20 h-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center h-full">
            {/* 右側:空白エリア(スマホでは上に表示) */}
            <div className="w-full flex justify-center lg:justify-end order-1 lg:order-2">
              <div className="w-60 h-48 md:w-80 md:h-96"></div>
            </div>
            
            {/* 左側:テキストコンテンツ(スマホでは下に表示) */}
            <div className="w-full max-w-4xl order-2 lg:order-1 pb-[20px] md:pb-0">
              <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 md:p-12 shadow-lg">
                <h1 className="text-2xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-black mb-4 md:mb-8 leading-relaxed">
                  人の可能性を<br />最大限に追求する
                </h1>
                <h2 className="text-xl md:text-3xl lg:text-4xl font-bold text-black leading-relaxed">
                  ナインバレー株式会社
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}